import { message, Modal } from 'antd'
import moment from 'moment'
import { reaction } from 'mobx'
import Store, { AppConfig, AppStore, GameLibraryStore, QueueStore } from './AppStore'
import {
  DWCheckWeiXinLoginHttp,
  UserInfoHS,
  UserInfoHSTemp,
  CreateOrderJavaHttpHS,
  createPayHS,
  DWGetIsRealNameAuthHttp,
  getIsNeedRealNameAuthHttpHS,
  isReceiveNewUserHS,
  queryUserMarkHS,
  grantCouponHS,
} from 'src/commons/store/UserStore'
import { getUserInfo, loginSuccess, checkDepositeOrderPayStatus, successByLoginPage } from './UserStore'
import { AbstractPolling } from 'src/commons/utils/Commons'
import { history } from 'src/commons/utils/WebCommons'
import { getPhpToken } from 'src/pc/utils/auth'
import { getActive1ConfigHS, DWgetUserGameStatus, GameListHS } from 'src/commons/store/GameStore'
import {
  ForbidInfoHS,
  GamePackageListHS,
  getGameLibraryByAppIdHS,
  getGameLibraryListHS,
} from 'src/commons/store/GameStore'
import {
  ChannelConfigHS,
  DWBeijingTime,
  DWCMSVersionHttp,
  DWGetModDataByDataIdHttp,
  DWGetModDataByModIdHttp,
  DWGetMultipleModDataByModIdHttp,
  GetContactUrlHS,
  GetPreProcessHS,
  statisticsApiHS,
  reportCloudArchivesDownloadNumHS,
  GetVipConfigJavaHS,
  GetVipInvitedUserPhoneHS,
} from 'src/commons/store/BasisStore'
import { CompareVersion, DownloadClient, downUrl, GetChannel, GUID, Random } from 'src/commons/utils'
import { GameAccountIsFullTitle } from 'src/commons/utils/DOMUtils'
import { JuvenileReminder } from 'src/commons/utils/DOMUtils'
import { DWbindInviter, DWVipBindInviter } from 'src/commons/store/BasisStore'
import { DWQueryResourceQueue } from 'src/commons/store/CloudGameStore'
import DDModal from 'src/pc/components/DDModal'
import useQueue from 'src/pc/components/hooks/useQueue'
import CloudGameClientStore from 'src/pc/store/cloudGame/cloudGameClientStore'
import useCloudGameStart from 'src/pc/components/hooks/useCloudGameStart'

// 季卡会员，月卡会员，年卡会员的id
export const vipIdArr = ['prod', 'pre'].includes(process.env.BUILD_TYPE)
  ? [1578282999, 1578281728, 1578281618]
  : [1578281137, 1578039816, 1578039690]

export const CheckWeiXinLogin = AbstractPolling((state: string) => {
  return DWCheckWeiXinLoginHttp.Execute({ state })
})
/** 实名认证和9+1活动弹框逻辑 */
export const authModalIsOpen = async () => {
  const showAuthModal = await isShowAuthModal(true)
  if (window.location.pathname === '/' && !showAuthModal) {
    viewActiveModal()
  }
}
/** 获取年卡送的加速器 */
export const getYearJsqDays = async () => {
  // 获取渠道配置的vip挡位
  const version = await getCMSVersion()
  const vipChannelRes = await DWGetModDataByModIdHttp.Execute({ modId: 'simpleclient_vipType_channel', version })
  const vipChannelList = vipChannelRes.datas.map(item => {
    return {
      channel: item.properties.channel,
      vipIds: item.properties.vipIds,
    }
  })
  // 获取所有会员挡位
  const VipListRes = await GetVipConfigJavaHS.Execute({ channel: GetChannel() })
  // 当前渠道是否配置了会员挡位
  const channelIndex = vipChannelList.findIndex(d => d.channel === GetChannel())
  console.log(channelIndex, vipChannelList, GetChannel())
  let vipIds = []
  if (channelIndex > -1) {
    vipIds = vipChannelList[channelIndex].vipIds.split(',')
  }
  // 如果当前渠道配置了会员挡位，使用配置的会员，反之取所有会员中的永久、年、天
  const vipList = []
  for (let i = 0; i < vipIds.length; i++) {
    for (let j = 0; j < VipListRes.length; j++) {
      if (vipIds[i] === `${VipListRes[j].id}`) {
        vipList.push(VipListRes[j])
      }
    }
  }
  let resultVipList = []
  if (vipList.length > 0) {
    resultVipList = vipList
  } else {
    const temp = VipListRes.sort((a, b) => a.sort - b.sort).filter((d, i) => vipIdArr.includes(d.id))
    resultVipList = temp
  }
  const yearJsqDays = resultVipList.filter((item, index) => item.id === vipIdArr[2])
  console.log('yearJsqDays', yearJsqDays)
  return {
    times: yearJsqDays[0]?.buyVipGetJsqTime,
    jsqName: yearJsqDays[0]?.buyVipGetJsqDesc,
  }
}
/** 绑定邀请码逻辑 */
export const bindInviteCode = async (code: string, callback?: () => void) => {
  try {
    const bindInviterResult = await DWbindInviter.Execute({ inviterCode: code })
    const vipBindInviterResult = await DWVipBindInviter.Execute({ mobile: bindInviterResult, isNew: 1 })
    callback && callback()
    isLogged().then(token => {
      getUserInfo(token)
    })
    if (
      !vipBindInviterResult.discount &&
      !vipBindInviterResult.inviteeGivingVipDays &&
      !vipBindInviterResult.beInviteeGivingVipDays &&
      !vipBindInviterResult.beInviterGivingVipDays
    ) {
      message.success('绑定邀请人成功')
      return
    }
    AppStore.bindResult = vipBindInviterResult
    AppStore.bindInvitationCodeSuccessModal = true
  } catch (error) {
    message.error(error.message)
  }
}

export const loadInClientToken = () => {
  const Query = new URLSearchParams(location.search)
  const token = Query.get('token')
  if (token) {
    localStorage.setItem('php-token', token)
  }
}

export const checkLoginStatus = async () => {
  // const Query = new URLSearchParams(location.search)
  // const forcelogon = Query.get('forcelogon') || undefined
  // const Query = new URLSearchParams(location.search)
  // const token = Query.get('token')
  const token = getPhpToken()

  // const version = await getCMSVersion()
  // const forcedRes = await DWGetModDataByModIdHttp.Execute({ modId: 'simpleclient_forced_landing_channel', version })
  // let forcedMode: 'block' | 'white' = 'block'

  // if (forcedRes.datas.length > 0) {
  //   forcedMode = forcedRes.datas[0].properties.useBlacklist === '0' ? 'white' : 'block'

  // }

  // console.log(token, 'token', '1')
  // if (!forcelogon) {
  //   /** 打开广告弹框 */
  //   openNotification()
  // }
  // if (forcelogon) {
  //   localStorage.setItem('forcelogon', '1')
  // }
  if (token) {
    successByLoginPage(token)
    return
  } else {
    window.FuluApp?.JSNotifyCppFunc('need_user_logon')
  }
}

/** 万圣节活动编号 */
export const MIDAUTUMNFESTIVAL_ACTIVITY_NO = 'AT5532805947697972881'

/** 是否需要实名认证 */
export const isNeedIdcardAuth = async () => {
  const result = await getIsNeedRealNameAuthHttpHS.Execute()
  return result
}

/* 是否实名认证过 */
export const isShowAuthModal = async (showModal: boolean) => {
  const token = getPhpToken()
  const result = await DWGetIsRealNameAuthHttp.Execute({ token })
  if (!result && showModal) {
    AppStore.realNameAuthModal = true
    return true
  }
  return false
}
/**关闭人工实名认证弹框*/
export const closeArtificialAuthModal = () => {
  AppStore.artificialAuthModal = false
  AppStore.realNameAuthModal = true
}
/* 关闭实名认证弹框 */
export const closeAuthModal = () => {
  AppStore.realNameAuthModal = false
  //如果是首页关闭则需要关闭后打开活动窗口
  if (window.location.pathname === '/') {
    viewActiveModal()
  }
}
/* 判断是否未成年 */
export const JuvenileLimit = (age: number | null | undefined) => {
  if (age && age < 18) {
    JuvenileReminder()
    return true
  }
  return false
}

/*显示登录框*/
export const ShowLoginModal = () => {
  ShowPhoneLoginModal()
  // if (window.WxLogin && !AppStore.notViewWechatEntry.includes(GetChannel())) {
  //   ShowWeiXinLogin()
  // } else {
  //   ShowPhoneLoginModal()
  // }
}
/*显示手机验证码登录框*/
export const ShowPhoneLoginModal = () => {
  AppStore.LoginModalVisible = true
}
/*隐藏手机验证码登录框*/
export const HidePhoneLoginModal = () => {
  AppStore.LoginModalVisible = false
}
/*显示微信登录框*/
export const ShowWeiXinLogin = () => {
  AppStore.WeiXinLoginVisible = true
  // GetWeiXinLoginQRCode.Execute()
}
export const GetWeiXinLoginQRCode: {
  StopPolling?: Function
  Execute: () => void
} = {
  Execute: () => {
    GetWeiXinLoginQRCode.StopPolling?.() //防止反复调用重复轮询
    AppStore.WeiXinLoginTimeout = false
    const state = GUID()
    window.setTimeout(() => {
      window.WxLogin!({
        self_redirect: true,
        id: 'WeiXinLogin',
        appid: 'wx0eb9a86b1e7c62b3',
        scope: 'snsapi_login',
        redirect_uri: `https://steam-api.99box.com/api/wechatLogin?env=${
          process.env.BUILD_TYPE.startsWith('prod') ? '' : 'test'
        }`,
        state,
        style: 'white',
        href: `data:text/css;base64,${window.btoa('.impowerBox .status_browser p:last-child {display: none;}')}`,
      })
    }, 200)
    GetWeiXinLoginQRCode.StopPolling = CheckWeiXinLogin(
      state,
      Result => {
        if (Result) {
          AppStore.WeChatLoginData = Result
          AppConfig.WeChatLoginUnionId = Result.unionid
          HidePhoneLoginModal()
          AppStore.WeiXinLoginVisible = false
          AppStore.WeiXinLoginTimeout = false
          if (Result.bind_mobile === 0) {
            /*未绑定手机号*/
            //查询头像、昵称
            UserInfoHSTemp.Execute({ token: Result.token })
            AppStore.WeChatBindMobileVisible = true
          } else {
            loginSuccess(Result.token)
            if (Result.is_new) {
              AppStore.inviteCodeModal = true
            }
          }
        }
      },
      () => {
        AppStore.WeiXinLoginTimeout = true
      },
    )
  },
}

export const HideWeChatLogin = () => {
  AppStore.WeiXinLoginVisible = false
  AppStore.WeiXinLoginTimeout = false
  AppStore.ShowBindWeiXin = false
  // GetWeiXinLoginQRCode.StopPolling?.()
}

export const gameStartingSuccess = () => {
  GameLibraryStore.gameStartingTimer && window.clearTimeout(GameLibraryStore.gameStartingTimer)
  AppStore.CheckModalVisible = false
  AppStore.minimizeGameCheckVisible = false
}

/*隐藏检测弹出框*/
export const HideCheckModal = () => {
  GameLibraryStore.gameStartingTimer && window.clearTimeout(GameLibraryStore.gameStartingTimer)
  GameLibraryStore.gameRunStatus = 'stop'
  window.FuluApp?.JSNotifyCppFunc('exit_game', 0)
  AppStore.CheckModalVisible = false
  AppStore.minimizeGameCheckVisible = false
}

/*打开应用程序*/
export const OpenProgram = (Name: string, value: string) => {
  if (window.FuluApp) {
    window.FuluApp.JSNotifyCppFunc('open_local_process', Name, value)
  } else {
    needClient()
  }
}

/*打开壁纸*/
export const OpenWallpaperApp = () => {
  isLogged().then(token => {
    OpenProgram('wallpaperUI.exe', token)
  })
}

/*动态壁纸保存 token*/
export const WallpaperSaveToken = () => {
  const Query = new URLSearchParams(window.location.search.substr(1, window.location.search.length))
  const token = Query.get('token')
  if (token) {
    // GetBoxWebPower.Execute({ token })
    localStorage.setItem('token', token)
  }
}

/*打开客服*/
export const OpenCustomerService = async (flag?: boolean) => {
  if (AppStore.standbyHelp) {
    const result = `https://help.99box.com?appName=海鲨游戏`
    if (window.FuluApp) {
      if (flag) {
        window.FuluApp!.JSNotifyCppFunc('online_customer_service', result)
      } else {
        isLogged().then(() => {
          window.FuluApp!.JSNotifyCppFunc('online_customer_service', result)
        })
      }
    } else {
      window.open(result, '_blank')
    }
  } else {
    window?.ddmt?.reportServiceEventReview?.()
    let result = ''
    try {
      result = await GetContactUrlHS.Execute({
        type: 16,
        mtKey: localStorage.getItem('ddmt-i') || '',
        token: getPhpToken() || '',
      })
    } catch (error) {}
    result = result || 'https://cschat-ccs.aliyun.com/index.htm?tntInstId=_1KlnA7c&scene=SCE00012020'

    if (window.FuluApp) {
      if (flag) {
        window.FuluApp!.JSNotifyCppFunc('online_customer_service', result)
      } else {
        isLogged().then(() => {
          window.FuluApp!.JSNotifyCppFunc('online_customer_service', result)
        })
      }
    } else {
      window.open(result, '_blank')
    }
  }
}

/*打开vip客服*/
export const OpenVipCustomerService = async (orderNo: string) => {
  let newWindow: Window | null
  const token = await isLogged()
  try {
    const result = await GetContactUrlHS.Execute({
      token,
      gameNo: orderNo,
      type: 16,
      mtKey: localStorage.getItem('ddmt-i') || '',
    })
    if (window.FuluApp) {
      window.FuluApp!.JSNotifyCppFunc('online_customer_service_vip', result)
    } else {
      newWindow = window.open()
      newWindow && (newWindow.location.href = result)
    }
  } catch (error) {
    message.warn((error as any).message)
  }
  // if (!window.FuluApp) {
  //   newWindow = window.open()
  // }
  // IsLogged()
  //   .then((token) => {
  //     return GetContactUrlHS.Execute({
  //       token,
  //       gameNo: orderNo,
  //       type: 2,
  //       mtKey: localStorage.getItem('ddmt-i') || ''
  //     })
  //   })
  //   .then((url) => {
  //     if (window.FuluApp) {
  //       window.FuluApp!.JSNotifyCppFunc('online_customer_service_vip', url)
  //     } else {
  //       ;(newWindow as Window).location.href = url
  //     }
  //   })
  //   .catch((e) => {
  //     console.log('e', e)
  //     ;(newWindow as Window).close()
  //   })
}

/*获取获取当前会话ID*/
export const getPreProcessInfo = () => {
  const channel = GetChannel()
  /*通过 URL 查询字段获取渠道*/
  const Query = new URLSearchParams(window.location.search.substr(1, window.location.search.length))
  GetPreProcessHS.Execute({
    sem: channel,
    searchKey: Query.get('kw') || '',
    actLoadUrl: downUrl(),
    defalutLoadUrl: 'http://download.99box.com/?f=steam9',
  })
}

/*页面最小化*/
export const PageMini = () => {
  window.FuluApp?.JSNotifyCppFunc('min_page')
}

/** 页面最大化切换 */
export const PageMax = () => {
  window.FuluApp?.JSNotifyCppFunc('max_page')
}

/** 切换窗口状态 */
export const changeWindowStatus = (status: 0 | 1 | 2) => {
  console.debug(
    `%c 切换窗口状态 current: ${AppStore.windowStatus} target: ${status}`,
    'font-size:20px;font-weight:bold;color:#7fea2d;',
  )
  /** 版本兼容 */
  if (!CompareWithCurrentVersion([2, 0, 0, 1931])) {
    /** 切换全屏 */
    if (status === 2 || AppStore.windowStatus === 2) {
      window.FuluApp?.JSNotifyCppFunc('set_full_screen')
    } else {
      PageMax()
    }
    return
  }
  window.FuluApp?.JSNotifyCppFunc('set_window_status', status, AppStore.windowStatus)
}

/** 启用/禁用鼠标快捷键 */
export const blockFsKeyboard = (status: number) => {
  window.FuluApp?.JSNotifyCppFunc('block_fs_keyboard', status)
}

/** 页面关闭 */
export const pageClose = () => {
  window.FuluApp?.JSNotifyCppFunc('close_page')
}
/*页面回退*/
export const pageGoBack = () => {
  history.goBack()
}

/*退出应用*/
export const AppExit = () => {
  window.FuluApp?.JSNotifyCppFunc('exit_app')
}
/*卸载应用*/
export const AppUninstall = () => {
  window.FuluApp?.JSNotifyCppFunc('uninstall')
}
/*重装应用*/
export const AppInstall = () => {
  window.FuluApp?.JSNotifyCppFunc('install')
}
/*真实卸载*/
export const AppReallyUninstall = () => {
  window.FuluApp?.JSNotifyCppFunc('really_uninstall')
}
/*启动主客户端*/
export const StartMainClient = () => {
  window.FuluApp?.JSNotifyCppFunc('start_client')
}
/*9+1活动弹框*/
export const viewActiveModal = async () => {
  const nineOneModal = sessionStorage.getItem('nine_one_modal')
  if (getPhpToken()) {
    const result = await getActive1ConfigHS.Execute({ activityType: 'nine_one' })
    console.log('result.lastTime', result)
    console.log('!nineOneModal', !nineOneModal)
    if (result.lastTime > 0 && !nineOneModal) {
      sessionStorage.setItem('nine_one_modal', '1')
      //暂时取消弹出9+1
      // AppStore.active1ModalVisible = true
    }
  }
}

/*重置检测步骤*/
const ResetCheckStep = () => {
  AppStore.GameCheckErrorStepMessage = undefined
  AppStore.GameCheckErrorStep = -1
  AppStore.GameCheckStep = 0
}

/*显示绑定手机号弹出框*/
export const showBindMobile = () => {
  AppStore.BindMobileVisible = true
}

/*取消绑定手机*/
export const CancelBindMobile = () => {
  AppStore.BindMobileVisible = false
}

/*重新启动游戏*/
export const ReStartGame = () => {
  AppStore.LastStartGameQuery && DoStartGame.Execute(...AppStore.LastStartGameQuery)
}

/*开始启动游戏*/
export const DoStartGame: {
  CheckTimer?: number
  Execute: (Game: StartGameBase, mode: 1 | 2 | 3, ArchiveKey?: string, type?: 0 | 1, jsqArea?: JsqAreaInfo) => void
} = {
  Execute: async (Game: StartGameBase, mode: 1 | 2 | 3, ArchiveKey?: string, type?: 0 | 1, jsqArea?: JsqAreaInfo) => {
    // 该方法已经废弃
  },
}

/*启动游戏*/
export const StartGame = (
  Game: StartGameBase,
  mode: 1 | 2 | 3,
  ArchiveKey?: string,
  type?: 0 | 1,
  jsqArea?: JsqAreaInfo,
) => {
  /*if (guard_status === 1) {
    return false
  }*/
  window.clearTimeout(DoStartGame.CheckTimer)
  if (window.FuluApp) {
    const ChannelConfig = ChannelConfigHS.SuccessResult
    AppStore.LastStartGameQuery = [Game, mode, ArchiveKey, type, jsqArea]
    if (!(ChannelConfig && ChannelConfig.is_checking === 1)) {
      /*非过白中*/
      if (CompareWithCurrentVersion([1, 0, 0, 560])) {
        window.FuluApp!.JSNotifyCppFunc('get_game_running_status')
      } else {
        DoStartGame.Execute(Game, mode, ArchiveKey, type, jsqArea)
      }
    }
  } else {
    needClient()
  }
}

/*隐藏游戏存档弹框*/
export const HideGameArchives = () => {
  AppStore.GameArchiveVisible = false
}

/*隐藏新游戏存档弹框*/
export const HideNewGameArchives = () => {
  AppStore.newSaveArchive.newGameArchiveVisible = false
}

/*加载提示线路满时间段和文案*/
export const getOnlineFull = () => {
  getCMSVersion().then(version => {
    DWGetModDataByModIdHttp.Execute({ modId: 'simpleshq_game_full', version }).then((data: ModData<any>) => {
      if (data?.datas?.[0]?.properties) {
        AppStore.gameOnlineFull = data.datas[0].properties
      }
    })
  })
}

/*启动游戏修复工具*/
export const GameRepair = () => {
  if (window.FuluApp) {
    isLogged().then(() => {
      const config = AppStore.GamePlatformConfig[100]
      AppStore.GamePlatformInstallStatus[100] = 2.01
      config &&
        window.FuluApp!.JSNotifyCppFunc('notify_gameplatform_download_info', 100, config.md5, config.url, config.extend)
    })
  } else {
    needClient()
  }
}

/** 打开gamebuff */
export const openStandAloneGame = () => {
  if (window.FuluApp) {
    window.FuluApp!.JSNotifyCppFunc('open_url', 'https://gamebuff.cn/gj/index.html')
  } else {
    window.open('https://gamebuff.cn/gj/index.html', '_blank')
  }
}

export const formatTimeFixedOffset = (timestamp: number) => {
  return timestamp + (480 - moment().utcOffset()) * 60 * 1000
}

/** 查询并同步其它端游戏状态 */
export const syncUserGameStatus = async () => {
  const { playing, queueing } = await DWgetUserGameStatus.Execute()
  const { writeQueueInfo, quitQueue } = useQueue()
  const { stopCloudGame } = useCloudGameStart()
  /** 排队中 */
  if (queueing && queueing.statusResultObject && QueueStore.queueStatus !== 'in') {
    writeQueueInfo(queueing)
  } else if (!queueing) {
    quitQueue()
  }
  /** 游戏中 移动端只有云游戏模式 */
  if (
    playing &&
    playing.terminal === 'h5' &&
    !['starting', 'running', 'tryRunning'].includes(GameLibraryStore.gameRunStatus)
  ) {
    CloudGameClientStore.gameCloudNo = playing.gameCloudOrderNo
    GameLibraryStore.gameRunStatus = 'running'
    GameLibraryStore.currentTheRunningGameInfo = {
      gameLibraryId: playing.gameLibraryId,
      gameLibraryName: playing.gameName,
      startGameOrderNo: playing.startGameNo || '',
      gameMode: 'cloud',
      allowExit: 'allowExit',
      terminal: playing.terminal,
      gameLibraryImg: '',
      gameVersionNo: '',
      versionName: '',
      putTypeIdentity: '',
      appId: '',
      gameStartTime: 0,
      platform: '1',
      isSupportArchive: false,
    }
  } else if (!playing && !CloudGameClientStore.visibleExitConfirmModal) {
    if (GameLibraryStore.currentTheRunningGameInfo?.gameMode === 'cloud') {
      stopCloudGame({ needRequest: false, needArchive: false, reason: '其它端游戏状态变为空闲' })
    } else {
      HideCheckModal()
    }
  }
}

/** 查询用户游戏状态
 *  status: 空闲：free, 排队中：queuing, 游戏中：playing
 */
export const loadUserGameStatus = () => {
  /*等待用户信息被加载*/
  const waitUserLogin = reaction(
    () => UserInfoHS.SuccessResult,
    async UserExtendInfo => {
      syncUserGameStatus()
      waitUserLogin()
    },
  )
}

export const CalcGamePrice = (Game: BaseGameList): number => {
  /*无论用户是不是会员 都展示会员价*/
  const { share_offline: shareOffline, share_online: shareOnline, alone } = Game
  let Price //合玩价格
  if (shareOffline) {
    /*支持离线*/
    const { price, vip_price: vipPrice } = shareOffline
    if (vipPrice === 0) {
      /*离线会员免费*/
      if (Price) {
        if (price < Price) {
          /*离线价更低*/
          Price = price //离线价
        }
      } else {
        Price = price //离线价
      }
    } else if (Price) {
      if (vipPrice < Price) {
        /*离线会员价更低*/
        Price = vipPrice //离线的会员价
      }
    } else {
      Price = vipPrice //离线的会员价
    }
  }
  if (shareOnline) {
    /*支持共享*/
    const { year_vip_price: yearVipPrice, vip_price: vipPrice, price } = shareOnline
    if (yearVipPrice !== undefined && yearVipPrice !== 0) {
      /*如果年会员有优惠 且年会员价格不是免费*/
      if (Price) {
        if (yearVipPrice < Price) {
          /*年会员优惠价格更低 */
          Price = yearVipPrice
        }
      } else {
        Price = yearVipPrice
      }
    }
    if (vipPrice !== 0) {
      /*如果会员不免费*/
      if (Price) {
        if (vipPrice < Price) {
          Price = vipPrice
        }
      } else {
        Price = vipPrice
      }
    }
    if (Price) {
      if (price < Price) {
        Price = price
      }
    } else {
      Price = price
    }
  }
  if (alone) {
    /*如果支持独享*/
    const { vip_price: vipPrice, price } = alone
    if (Price) {
      if (vipPrice !== 0 && vipPrice < Price) {
        /*非会员免费 且价格更低*/
        Price = vipPrice
      }
    } else {
      Price = vipPrice
    }
    if (Price) {
      if (price < Price) {
        /*价格更低*/
        Price = price
      }
    } else {
      Price = price
    }
  }
  return Price || 0
}
export const formatJavaPayMethod = (payWay: TPayWay) => {
  switch (payWay) {
    case 'alipay':
      return 'alipay_scan'
    case 'wechat':
      return 'wechat_scan'
    case 'qq_wallet':
      return 'qq_scan'
  }
  return 'alipay_scan'
}
/*缴纳保证金*/
export const ChargeDeposit: {
  StopPolling?: Function
  Execute: (
    payType: TPayWay,
    gameId: number,
    chargeDepositOrderCancel: Function,
    showPayChargeDeposit: () => void,
  ) => void
} = {
  Execute: (payType: TPayWay, gameId: number, chargeDepositOrderCancel: Function, showPayChargeDeposit: () => void) => {
    ChargeDeposit.StopPolling?.()
    isLogged().then(async token => {
      try {
        const createJavaOrderHttpResult = await CreateOrderJavaHttpHS.Execute({
          gameId,
          useBalance: 0,
          balanceType: undefined,
          orderType: 30,
        })

        const success = () => {
          message.success('已支付押金，您可开始畅玩游戏')
          chargeDepositOrderCancel()
          ForbidInfoHS.Execute({ page: 'start' }) // 更新禁封状态
        }

        if (createJavaOrderHttpResult.hasThridPay === 0) {
          success()
          return
        }

        const formatPayMethod = formatJavaPayMethod(payType)
        const orderNo = createJavaOrderHttpResult.orderNo
        await createPayHS.Execute({
          balanceNo: createJavaOrderHttpResult.balanceNo,
          payMode: formatPayMethod,
        })

        showPayChargeDeposit()

        ChargeDeposit.StopPolling = checkDepositeOrderPayStatus(
          { order_no: orderNo, order_type: 'deposit' },
          () => {
            message.success('已支付押金，您可开始畅玩游戏')
            chargeDepositOrderCancel()
            ForbidInfoHS.Execute({ page: 'start' }) //更新禁封状态
          },
          () => {
            message.warning('支付订单超时!')
            chargeDepositOrderCancel()
          },
        )
      } catch (error) {
        message.warning((error as any).message)
      }
    })
  },
}
/*获取禁售游戏配置*/
/*export const NotSaleGameConfig = () => {
  DWGetModDataByModIdHttp.Execute({ modId: 'simpleshq_share_hide' }).then((data: ModData<{ gameid: string; mode: 2 | 3 }>) => {
    const NotSaleGame: { [key in 3 | 2]?: number[] } = {}
    data.datas.forEach(d => {
      NotSaleGame[d.properties.mode] = d.properties.gameid.split(',').map(d => Number(d))
    })
    AppStore.NotSaleGameConfig = NotSaleGame
  })
}*/

export const loadCMSConfig = () => {
  DWCMSVersionHttp.Execute().then(res => {
    const version = `${res}_${window.location.host}`
    AppStore.CMSVersion = version
    /** 一次性只能取20个cms配置，否则会出异常，所以再增加请添加到 modIds1 这个变量里面 */
    const modIds = [
      'simpleshq_buy_mode',
      'simpleshq_tools_platform',
      'simpleshq_buy_title',
      'simpleshq_new_sale_protocol',
      'simpleshq_steam_uplay',
      'simple_refound_note',
      'simpleshq_game_cundang',
      'simpleshq_steam_message',
      'simpleshq_speed_banner',
      'simpleclient_cloud_info_config',
      'simpleshq_start_timeout',
      'simpleshq_set_timeout',
      'simpleshq_home_verify',
      'simpleshq_notView_wechat',
      'simpleclient_floatImg_config',
      'simpleclient_pay_tips',
      'simpleclient_cdk_extracturl',
      'simpleclient_new_active_channel',
      'simpleshq_binding_cloud_time',
    ].join(',')
    DWGetMultipleModDataByModIdHttp.Execute({ modIds, version }).then((data: Array<ModData<any>>) => {
      data.forEach(d => {
        switch (d.modId) {
          case 'simpleclient_cdk_extracturl':
            loadCDKExtractUrl(d)
            break
          case 'simpleclient_floatImg_config':
            loadFloatImgConfig(d)
            break
          case 'simpleclient_new_active_channel':
            loadActivityChannel(d)
            break
          case 'simpleshq_buy_mode':
            LoadBuyModeConfig(d)
            break
          case 'simpleshq_tools_platform':
            LoadGamePlatformConfig(d)
            break
          case 'simpleshq_buy_title':
            LoadBuyTitleConfig(d)
            break
          case 'simpleshq_new_sale_protocol':
            LoadAgreementConfig(d, version)
            break
          case 'simpleshq_steam_uplay':
            SteamVerUplayGameTips(d)
            break
          case 'simple_refound_note':
            RefundPromiseConfig(d)
            break
          case 'simpleshq_game_cundang':
            NotArchiveGamesConfig(d)
            break
          case 'simpleshq_steam_message':
            LoadStartPlatformConfig(d)
            break
          case 'simpleshq_speed_banner':
            LoadJsqConfig(d)
            break
          case 'simpleclient_cloud_info_config':
            loadCloudTimeConfig(d)
            break
          case 'simpleshq_start_timeout':
            LoadStartTimeOutConfig(d)
            break
          case 'simpleshq_set_timeout':
            LoadStartGameTimeOutConfig(d)
            break
          case 'simpleshq_home_verify':
            LoadNotShowVerify(d)
            break
          case 'simpleshq_notView_wechat':
            loadNotViewWechat(d)
            break
          case 'simpleclient_pay_tips':
            loadPayTips(d)
            break
          case 'simpleshq_binding_cloud_time':
            loadBindingCloudGameTime(d)
            break
          default:
            break
        }
      })
    })

    const modIds1 = [
      'simpleclient_floatIcon_config',
      'simpleclient_BBS_View',
      'simpleclient_c5_channel',
      'vip_activity_channel',
      'simpleclient_fastRefund_config',
      'pubg_banner_config',
      'client_upgrade_config',
      'simpleclient_buy_promise_config',
      'simpleclient_anchor_config',
      'simpleclient_anchor_info',
      'simpleclient_accounttype_description',
      'simpleclient_accountDescription_config',
      'simpleclient_start_help_config',
      'simpleclient_global_qq_config',
      'simpleshq_cloud_mobileqrcode',
      'guansha_active12_code',
      'common_help_config',
      'simpleshq_coupon_tag_config',
      'simpleshq_auth_switch',
      'simpleshq_alone_switch',
    ].join(',')
    AppStore.CSGOIsLoadingEnd = false
    DWGetMultipleModDataByModIdHttp.Execute({ modIds: modIds1, version }).then((data: Array<ModData<any>>) => {
      data.forEach(d => {
        switch (d.modId) {
          case 'common_help_config':
            loadCommonHelpConfig(d)
            break
          case 'simpleclient_accountDescription_config':
            loadAccountDescriptionConfig(d)
            break
          case 'simpleclient_accounttype_description':
            loadAccountTypeDescription(d)
            break
          case 'client_upgrade_config':
            loadUpgradeConfig(d)
            break
          case 'simpleclient_floatIcon_config':
            loadFloatIconConfig(d)
            break
          case 'simpleclient_c5_channel':
            loadC5Blacklist(d)
            break
          case 'simpleclient_BBS_View':
            loadBBSViewConfig(d)
            break
          case 'vip_activity_channel':
            loadVipBlacklist(d)
            break
          case 'simpleclient_fastRefund_config':
            LoadFastRefundConfig(d)
            break
          case 'pubg_banner_config':
            loadPUBGBannerConfig(d)
            break
          case 'simpleclient_buy_promise_config':
            loadBuyPromiseConfig(d)
            break
          case 'simpleclient_anchor_config':
            loadAnchorConfig(d)
            break
          case 'simpleclient_start_help_config':
            loadStartHelpConfig(d)
            break
          case 'simpleclient_global_qq_config':
            loadQQConfig(d)
            break
          case 'simpleshq_cloud_mobileqrcode':
            loadMobileDownload(d)
            break
          case 'guansha_active12_code':
            loadActive12Code(d)
            break
          case 'simpleshq_coupon_tag_config':
            loadCouponTagConfig(d)
            break
          case 'simpleshq_auth_switch':
            loadAuthSwitchConfig(d)
            break
          case 'simpleshq_alone_switch':
            loadAloneSwitch(d)
            break
          default:
            break
        }
      })
    })

    const modIds2 = ['guansha_community_config'].join(',')
    DWGetMultipleModDataByModIdHttp.Execute({ modIds: modIds2, version }).then((data: Array<ModData<any>>) => {
      data.forEach(d => {
        switch (d.modId) {
          case 'guansha_community_config':
            loadCommunityConfig(d)
            break
          default:
            break
        }
      })
    })
  })
}
/** 加载社群消息配置 */
const loadCommunityConfig = (data: ModData<{ title: string; img: string; desc: string; type: '1' | '2' | '3' }>) => {
  const refundCommunity = data?.datas?.filter(d => d.properties.type === '2')
  if (refundCommunity && refundCommunity.length > 0) {
    const matchReg = /\{([^}]*)\}/gi
    const { title, img, desc } = refundCommunity[0].properties
    AppStore.refundCommunity = { title, img, desc: desc.match(matchReg)?.map(x => x.replace(matchReg, '$1')) || [] }
  }
  const buySuccessCommunity = data?.datas?.filter(d => d.properties.type === '1')
  if (buySuccessCommunity && buySuccessCommunity.length > 0) {
    const matchReg = /\{([^}]*)\}/gi
    const { title, img, desc } = buySuccessCommunity[0].properties
    AppStore.buySuccessCommunity = { title, img, desc: desc.match(matchReg)?.map(x => x.replace(matchReg, '$1')) || [] }
  }
  const startCommnunity = data?.datas?.filter(d => d.properties.type === '3')
  if (startCommnunity && startCommnunity.length > 0) {
    const matchReg = /\{([^}]*)\}/gi
    const { title, img, desc } = startCommnunity[0].properties
    AppStore.startCommnunity = { title, img, desc: desc.match(matchReg)?.map(x => x.replace(matchReg, '$1')) || [] }
  }
}
const loadAloneSwitch = (data: ModData<{ close: string; gameId: string }>) => {
  const temp = data?.datas?.[0]?.properties
  AppStore.closealoneSwitchConfig = temp?.close === '1'
  AppStore.closeAloneSwitchwhiteList = temp?.gameId.split(',') || []
}
/** 加载实名认证弹框开关配置 */
const loadAuthSwitchConfig = (data: ModData<{ login: string; buy: string; start: string }>) => {
  const temp = data?.datas?.[0]?.properties
  AppStore.authSwitchConfig.loginFlag = temp.login === '1'
  AppStore.authSwitchConfig.buyFlag = temp.buy === '1'
  AppStore.authSwitchConfig.startFlag = temp.start === '1'
}
const loadCouponTagConfig = (data: ModData<{ open: string }>) => {
  AppStore.couponTagVisible = data?.datas?.[0]?.properties?.open === '1'
}
const loadCommonHelpConfig = (data: ModData<Tools.KeyValueProp<string>>) => {
  const config = data?.datas?.[0]?.properties?.['管鲨客户端'] === '1'
  if (config) {
    AppStore.standbyHelp = true
  }
}

/** 加载双12群 */
const loadActive12Code = (data: ModData<{ img: string }>) => {
  AppStore.active12Code = data.datas?.[0]?.properties.img
}

/** 加载全局的移动端下载二维码 */
const loadMobileDownload = (data: ModData<{ img: string }>) => {
  AppStore.mobileDownload = data.datas?.[0].properties.img
}
/** 加载全局QQ群配置信息 */
const loadQQConfig = (data: ModData<{ GameQQlink: string; GameQQnumber: string; GameQQnumberpic: string }>) => {
  AppStore.QQConfig = data.datas?.[0].properties
}

/** 加载上号平台帮助 */
const loadStartHelpConfig = (data: ModData<TStartHelpConfig>) => {
  AppStore.startHelpConfig = data.datas?.[0].properties
  console.log(AppStore.startHelpConfig, '加载上号平台帮助')
}
/** 载入主播相关配置 qq群 规则 主播推荐 */
const loadAnchorConfig = (
  data: ModData<{ ids?: string; qq?: string; rules?: string; discount?: string; gamesNum?: string }>,
) => {
  AppStore.anchorConfig = data.datas?.[0].properties
}
/** 加载下单页承诺文案 */
const loadBuyPromiseConfig = (
  data: ModData<{ notSupportTypes: string; img: string; title: string; description: string }>,
) => {
  AppStore.buyPromiseConfig = data.datas?.map(d => {
    return {
      ...d.properties,
      notSupportTypes: d.properties.notSupportTypes ? d.properties.notSupportTypes.split(',') : [],
    }
  })
}

/** 加载 */
const loadPUBGBannerConfig = (
  data: ModData<{ imgUrl: string; targetUrl: string; viewIds: string; newUrl: string }>,
) => {
  AppStore.PUBGBannerConfig = data.datas?.[0].properties
}

/** 加载需要显示极速退款的游戏 */
const LoadFastRefundConfig = (data: ModData<{ gameId: string }>) => {
  AppStore.viewFastRefundIds = data.datas.map(d => d.properties.gameId)
}

/** 加载VIP活动黑名单 */
const loadVipBlacklist = (data: ModData<{ channel: string }>) => {
  if (data && data.datas && data.datas[0] && data.datas[0].properties?.channel) {
    const channelBlacklist = data.datas[0].properties?.channel.split(',')
    const channel = GetChannel()
    AppStore.vipActivityChannel = !channelBlacklist.includes(channel)
  }
}

/** 加载c5渠道黑名单 */
const loadC5Blacklist = (data: ModData<{ channel: string }>) => {
  console.log('loadC5Blacklist', data)
  if (data && data.datas && data.datas[0] && data.datas[0].properties?.channel) {
    const channelBlacklist = data.datas[0].properties?.channel.split(',')
    const channel = GetChannel()
    AppStore.isShowC5Tab = !channelBlacklist.includes(channel)
    AppStore.CSGOIsLoadingEnd = true
  }
}

/** 加载首页礼包列表配置 */
export const loadHomePackageConfig = (ids: string) => {
  GamePackageListHS.Execute({ ids: ids }).then(res => {
    const idsArr = ids.split(',')
    AppStore.homePackageList = res.sort((a: GamePackageList, b: GamePackageList) => {
      const aIndex = idsArr.indexOf(`${a.id}`)
      const bIndex = idsArr.indexOf(`${b.id}`)
      return aIndex - bIndex
    })
  })
}

/** 加载需要展示论坛的游戏 */
const loadBBSViewConfig = (data: ModData<{ ids: string }>) => {
  if (data && data.datas && data.datas[0]) {
    AppStore.viewBBSIds = data.datas[0].properties.ids.split(',')
  }
}

/** 加载 购买页-共享独享区别文案 */
const loadAccountDescriptionConfig = (data: ModData<TAccountDescriptionConfig>) => {
  if (data) {
    AppStore.accountDescriptionConfig = data.datas
      .sort((a, b) => {
        return Number(a.properties.sort || 999) - Number(b.properties.sort || 999)
      })
      .map(d => d.properties)
  }
}

/** 加载 购买页-账号类型的描述文案 */
export const loadAccountTypeDescription = (data: ModData<TAccountTypeDescription>) => {
  if (data?.datas?.[0]?.properties) {
    AppStore.accountTypeDescription = data.datas[0].properties
  }
}

/** 加载订单升级配置 */
const loadUpgradeConfig = (data: ModData<{ textUpgradeCDK: string; textUpgradeAccount: string }>) => {
  if (data && data.datas && data.datas[0]) {
    AppStore.orderUpgradeText = data.datas[0].properties
  }
}

/** 加载右下角浮动的活动入口配置 */
const loadFloatIconConfig = (data: ModData<{ img: string; newUrl: string; jump: 'in' | 'out' }>) => {
  if (data && data.datas && data.datas[0]) {
    AppStore.floatIconConfig = {
      ...data.datas[0].properties,
      path: data.datas[0].properties.newUrl,
    }
  }
}

/** 加载cdk兑换教程地址 */
const loadCDKExtractUrl = (data: ModData<{ newUrl: string }>) => {
  data.datas.forEach(d => {
    AppStore.cdkExtractUrl = d.properties.newUrl
  })
}

/** 加载首页浮动按钮显示配置 */
const loadFloatImgConfig = (data: ModData<{ key: string; view: '1' | any }>) => {
  AppStore.gameReplaceFloatVisible = data.datas[0].properties.view === '1'
}

/** 加载活动黑名单配置 */
const loadActivityChannel = (data: ModData<{ key: string; channel: string }>) => {
  console.log(data.datas, '加载活动黑名单配置 ')
  AppStore.activityChannel = data.datas.map(d => d.properties)
}

/** 加载选择微信支付方式的提示 */
const loadPayTips = (
  data: ModData<{ gog商城: string; letplay商城: string; letplay客户端: string; 管家客户端: string; 新版管家: string }>,
) => {
  if (data.datas && data.datas[0]) {
    AppStore.switchPayTips = data.datas[0].properties
  }
}

/** 绑定的云游戏时长商品 */
const loadBindingCloudGameTime = (data: ModData<{ goods: string }>) => {
  const goods = data?.datas?.[0]?.properties?.goods
  if (goods) {
    AppStore.bindingCloudGameTime = goods
  }
}

/** 加载不展示微信登录路口的渠道 */
const loadNotViewWechat = (data: ModData<{ channel: string }>) => {
  AppStore.notViewWechatEntry = data.datas.map(d => d.properties.channel)
}

/**加载购买类型配置*/
const LoadBuyModeConfig = (
  data: ModData<{ mode: 2 | 3; cn: string; name: string; gameid?: string; cn2: string; limitgameid?: string }>,
) => {
  const buyTypeDesc: {
    [key in 3 | 2]?: { tips: string; name: string; games: number[]; tips2: string; LimitGames: number[] }
  } = {}
  data.datas.forEach(d => {
    buyTypeDesc[d.properties.mode] = {
      tips: d.properties.cn,
      name: d.properties.name,
      tips2: d.properties.cn2,
      games: (d.properties.gameid && d.properties.gameid.split(',').map(Number)) || [],
      LimitGames: d.properties.limitgameid?.split(',').map(Number) || [],
    }
  })
  AppStore.buyModeConfig = buyTypeDesc
}
/**加载游戏平台配置*/
const LoadGamePlatformConfig = (data: ModData<any>) => {
  const config: { [key in GamePlatform]?: { url: string; md5: string; extend: string } } = {}
  for (const key of data.datas) {
    config[key.properties.platform as GamePlatform] = {
      md5: key.properties.md5,
      extend: key.properties.name,
      url: key.properties.url,
    }
  }
  AppStore.GamePlatformConfig = config
}
/**加载购买类型标题*/
const LoadBuyTitleConfig = (data: ModData<{ [key in 'ver' | 'type']?: string }>) => {
  if (data.datas[0]) {
    AppStore.BuyTypeTitle = data.datas[0].properties
  }
}
/**加载协议配置*/
const LoadAgreementConfig = (
  data: ModData<{ keyword: AgreementType; title: string; content: string }>,
  version: string,
) => {
  data.datas.forEach(d => {
    DWGetModDataByDataIdHttp.Execute({ dataId: d.dataId, version }).then(
      ({ properties }: ModDataItem<{ keyword: AgreementType; title: string; content: string }>) => {
        AppStore.AgreementConfig[properties.keyword] = { title: properties.title, content: properties.content }
      },
    )
  })
}
/**Steam版 Uplay 游戏提示*/
const SteamVerUplayGameTips = (data: ModData<{ content: string; gameid: string }>) => {
  const res = data.datas[0]
  if (res) {
    const Games = res.properties.gameid.split(',')
    AppStore.SteamVerUplayGameInfo = { Games, content: res.properties.content }
  }
}
/**获取退款承诺配置*/
const RefundPromiseConfig = (data: ModData<{ content: string; description: string; logo: string; colour: string }>) => {
  AppStore.RefundPromiseConfig = data.datas.map(item => item.properties)
}

/**没有存档游戏提示游戏提示*/
const NotArchiveGamesConfig = (data: ModData<{ content: string; gameid: string }>) => {
  const res = data.datas[0]
  if (res) {
    const Games = res.properties.gameid.split(',').map(Number)
    AppStore.NotArchiveConfig = { Games, content: res.properties.content }
  }
}

/**加载平台启动配置项*/
const LoadStartPlatformConfig = (data: ModData<TStartPlatformConfig>) => {
  data.datas.forEach(d => {
    AppConfig.StartPlatformConfig[d.properties.platform] = {
      ErrorMsg: d.properties.error_msg,
      CommandLine: d.properties.commandline,
    }
  })
}
/**加载加速器配置*/
const LoadJsqConfig = (data: ModData<any>) => {
  const res = data.datas[0]
  if (res) {
    AppStore.JsqConfig = res.properties
  }
}
/** 加载充值云游戏时长配置 */
const loadCloudTimeConfig = (data: ModData<any>) => {
  if (data) {
    AppStore.cloudTimeConfig = data.datas.map(d => d.properties)
  }
}
/**获取 CMS 缓存版本*/
export const getCMSVersion = (): Promise<string> => {
  return new Promise(resolve => {
    if (AppStore.CMSVersion) {
      resolve(AppStore.CMSVersion)
    } else {
      const WaitCMSVersion = reaction(
        () => AppStore.CMSVersion,
        version => {
          WaitCMSVersion()
          resolve(version!)
        },
      )
    }
  })
}
/**客服*/
export const CustomerService = (flag?: boolean) => {
  return {
    onClick: () => OpenCustomerService(flag),
  }
}

/**vip客服*/
export const CustomerVipService = () => {
  return {
    onClick: () => OpenCustomerService(),
  }
}

/** 加载启动超时配置*/
const LoadStartTimeOutConfig = (data: ModData<any>) => {
  const res = data.datas[0]
  if (res) {
    AppStore.StartTimeoutConfig = res.properties
  }
}
/** 加载启动游戏超时配置*/
const LoadStartGameTimeOutConfig = (data: ModData<{ Platform?: GamePlatform; time: string }>) => {
  data.datas.forEach(d => {
    if (d.properties.Platform) {
      AppStore.StartGameTimeoutConfig[d.properties.Platform] = Number(d.properties.time)
    } else {
      AppStore.StartGameTimeoutConfig.default = Number(d.properties.time)
    }
  })
}
/**卸载迈克菲*/
export const UninstallMkf = () => {
  if (window.FuluApp) {
    isLogged().then(() => {
      const config = AppStore.GamePlatformConfig[101]
      config &&
        window.FuluApp!.JSNotifyCppFunc('notify_gameplatform_download_info', 101, config.md5, config.url, config.extend)
    })
  } else {
    needClient()
  }
}

/**
 * 是否登录
 */
export const isLogged = async () => {
  const token = getPhpToken()
  if (token) {
    return token
  }
  ShowLoginModal()
  throw new Error('您还未登录!')
}

/**
 * 判断当前版本是否大于指定版本
 * @param ver 指定版本
 */
export const CompareWithCurrentVersion = (ver: [number, number, number, number]) => {
  if (AppConfig.Version) {
    const CurrentVersion = AppConfig.Version.split('.').map(d => Number(d))
    return CompareVersion(CurrentVersion, ver)
  }
  return false
}

/**
 * 需要安装客户端
 * */
export const needClient = () => {
  DDModal.warn({
    title: '提示',
    content: '为保障你的游戏账号安全，请下载PC端客户端后使用该功能！点击“确定”下载最新版本',
    okText: '确定',
    zIndex: 1060,
    onOk: () => {
      DownloadClient()
    },
  })
}

/** 下载存档 */
export const downloadArchive = async (d: TFinalArchive, e?: React.MouseEvent<HTMLSpanElement, MouseEvent>) => {
  e?.stopPropagation()
  if (Store.isInClient) {
    const orderNo = d.key.split('#')[1]
    const path = d.key.split('#')[0]
    if (d.diy === 0) {
      reportCloudArchivesDownloadNumHS.Execute({ orderNo: d.orderNo || '' })
    }
    await AppStore.cloudSaveInstance?.noticeClient('DownloadCloudArchives', {
      order_no: orderNo,
      oss_path: path,
      name: d.name,
      archives_create_time: d.time / 1000,
      is_save_down_info: 1,
      save_archives_count: 999,
    })
  } else {
    needClient()
  }
}

export const LoadNotShowVerify = (data: ModData<{ channel: string; switch: string }>) => {
  const info = data.datas[0]
  if (info) {
    if (info.properties.switch === '0') {
      AppStore.NotShowVerify = info.properties.channel.split(',')
    }
  }
}

type NotificationConfig = {
  autoCloseTime: string
  height: string
  width: string
  source: string
  sourceType: 'image' | 'video'
  target: 'in' | 'out'
  text: string
  url: string
}

/** 打开广告 */
export const openNotification = (token?: string) => {
  const phpToken = token || getPhpToken()
  if (window.location.pathname === '/notification' || !phpToken || sessionStorage.getItem('opennotification')) {
    return
  }
  getCMSVersion().then(version => {
    DWGetModDataByModIdHttp.Execute({ modId: 'simpleshq_Notification_config', version }).then(
      (res: ModData<NotificationConfig>) => {
        const config = res.datas?.[0]?.properties
        if (config) {
          sessionStorage.setItem('opennotification', 'true')
          window.FuluApp?.JSNotifyCppFunc(
            'show_popup_window',
            `${window.location.origin}/notification`,
            config.width,
            config.height,
          )
        }
      },
    )
  })
}

/** 等待用户登录 */
export const delayUserLogin = () => {
  if (UserInfoHS.SuccessResult) {
    return true
  }
  return new Promise((res, rej) => {
    const waitUserLogin = reaction(
      () => UserInfoHS.SuccessResult,
      async userInfo => {
        res(true)
        waitUserLogin()
      },
    )
  })
}

/** 判断url上面有没有 */
export const loadLinkGame = async (linkgameid: number | string | null) => {
  if (!linkgameid) {
    return
  }
  const token = getPhpToken()
  /** 用户未登录直接跳转首页 */
  if (!token) {
    return commonJump('/home')
  }
  try {
    const gameLibraryGame = await getGameLibraryByAppIdHS.Execute({ appid: linkgameid })
    if (!gameLibraryGame) {
      throw new Error('没有该游戏')
    }
    const result = await Promise.race([delayUserLogin(), sleep(5 * 1000)])
    if (result === 'sleep') {
      throw new Error('用户登录超时')
    }
    const gameLibraryList = await getGameLibraryListHS.Execute({ pageNo: 1, pageSize: 999 })
    const hasCurrentGame = gameLibraryList.find(d => d.gameLibraryId === gameLibraryGame.gameLibraryId)
    if (!hasCurrentGame) {
      throw new Error('没有该游戏')
    }
    GameLibraryStore.currentGameLibraryGame = {
      ...gameLibraryGame,
    }
    commonJump('/my-game')
  } catch (error) {
    return commonJump('/home')
  }
}

/** 阻塞函数 */
export const sleep = async (time: number) => {
  return new Promise((res, rej) => {
    setTimeout(() => {
      res('sleep')
    }, time)
  })
}

/** 用户引导 */
export const userGuidance = async () => {
  const firstIn = localStorage.getItem('firstIn')
  localStorage.setItem('firstIn', '1')
  const Query = new URLSearchParams(location.search.substr(1, location.search.length))
  const clientName = Query.get('SetupName')
  if (!firstIn) {
    AppStore.isFirstOpenClient = true
    AppStore.welcomeModalVisible = false //首先不开启打开新人领游戏弹框
  } else {
    AppStore.isFirstOpenClient = false
    /** 非首次打开 */
    if (getPhpToken()) {
      /** 已登录过 */
      viewActiveModal()
    } else {
      /** 未登录过 */
      await isLogged()
    }
  }
  //4749
  // clientName = 'bid0-lid1-steam.game_steam9_1.0.0.1659@nbant@gog'
  if (clientName) {
    let buyGameId: string | null | number = clientName.split('-')[0]
    buyGameId = buyGameId?.includes('bid') ? buyGameId.replace('bid', '') : null
    let lookGameId: string | null | number = clientName.split('-')[1]
    lookGameId = lookGameId?.includes('lid') ? lookGameId.replace('lid', '') : null
    //购买标识 4749
    if (buyGameId && buyGameId !== '0') {
      /** 已购买游戏 */
      try {
        statisticsApiHS.Execute()
      } catch (error) {}
      if (!firstIn) {
        AppStore.firstInGameId = Number(buyGameId) //购买标识符
        // history.push('/my-game')
        return
      }
    }
    //SEM标识 4749
    if (lookGameId && lookGameId !== '0') {
      try {
        statisticsApiHS.Execute()
      } catch (error) {}
      AppStore.semGameDetailId = Number(lookGameId)
      return
    }
  }
}

/** 计算文本长度 */
export const getTextWidth = (text: string, style?: Partial<{ fontSize: string; fontWeight: string }>) => {
  const DOM = document.createElement('span')
  if (style) {
    DOM.style.fontSize = style.fontSize || '12px'
    DOM.style.fontWeight = style.fontWeight || '400'
    DOM.style.whiteSpace = 'nowrap'
  }
  DOM.innerText = text
  document.body.appendChild(DOM)
  const width = DOM.offsetWidth
  document.body.removeChild(DOM)
  return width
}

/** 获取平台&游戏的cdk使用帮助图片 */
export const getPlatFormCdkHelp = () => {
  getCMSVersion().then(version => {
    DWGetModDataByModIdHttp.Execute({ modId: 'simpleclient_cdk_help_url', version }).then(res => {
      if (res.datas && res.datas.length > 0) {
        AppStore.platFormProp = res.datas.map(item => {
          return item.properties
        })
      }
    })
  })
}

/** 获取当前服务器时间 */
export const getCurrentServerTime = async () => {
  const res = await DWBeijingTime.Execute()
  return Number(res.time) * 1000
}

/** 避免精度问题的加法 */
export const sum = (a: number, b: number) => {
  let r1
  let r2
  try {
    r1 = a.toString().split('.')[1].length
  } catch (e) {
    r1 = 0
  }
  try {
    r2 = b.toString().split('.')[1].length
  } catch (e) {
    r2 = 0
  }
  const m = Math.pow(10, Math.max(r1, r2))
  return (a * m + b * m) / m
}

/** 避免精度问题的减法 */
export const subtract = (a: number, b: number) => {
  let r1
  let r2
  try {
    r1 = a.toString().split('.')[1].length
  } catch (e) {
    r1 = 0
  }
  try {
    r2 = b.toString().split('.')[1].length
  } catch (e) {
    r2 = 0
  }
  const m = Math.pow(10, Math.max(r1, r2))
  const n = r1 >= r2 ? r1 : r2
  return Number(((a * m - b * m) / m).toFixed(n))
}

/** 避免精度问题的乘法 */
export const multiply = (a: number, b: number) => {
  let m = 0
  const s1 = a.toString()
  const s2 = b.toString()
  try {
    m += s1.split('.')[1].length
  } catch (e) {}
  try {
    m += s2.split('.')[1].length
  } catch (e) {}
  return (Number(s1.replace('.', '')) * Number(s2.replace('.', ''))) / Math.pow(10, m)
}

export const division = (a: number, b: number) => {
  let t1 = 0
  let t2 = 0
  try {
    t1 = a.toString().split('.')[1].length
  } catch (e) {}
  try {
    t2 = b.toString().split('.')[1].length
  } catch (e) {}
  const r1 = Number(a.toString().replace('.', ''))
  const r2 = Number(b.toString().replace('.', ''))
  return multiply(r1 / r2, Math.pow(10, t2 - t1))
}

/** 前往下单页 */
export const toBuyDetail = (gameId: number | string, accountType: number | string, search?: string) => {
  history.push(`/store/goods/${gameId}/buy/${accountType}${search || ''}`)
}

/** 下单页的地址 */
export const getBuyDetailUrl = (gameId: number | string, accountType: number | string, search?: string) => {
  return `/store/goods/${gameId}/buy/${accountType}${search || ''}`
}

/** 前往礼包下单页 */
export const toPackageBuyDetail = (packageId: number | string) => {
  history.push(`/store/goods/${packageId}/buy/88`)
}

/** 礼包下单页地址 */
export const getPackageBuyDetailUrl = (packageId: number | string) => {
  return `/store/goods/${packageId}/buy/88`
}

/** 前往vip下单页地址 */
export const toVipBuyDetailUrl = (vipId: number | string) => {
  history.push(`/home/vip/goods/${vipId}/buy/66`)
}

/** vip下单页地址 */
export const getVipBuyDetailUrl = (vipId: number | string) => {
  return `/home/vip/goods/${vipId}/buy/66`
}

/** 前往加速器下单页地址 */
export const toBoosterBuyDetailUrl = (boosterId: number | string) => {
  history.push(`/store/goods/${boosterId}/buy/77`)
}

/** 加速器下单页地址 */
export const getBoosterBuyDetailUrl = (boosterId: number | string) => {
  return `/store/goods/${boosterId}/buy/77`
}

/** 云游戏下单页地址 */
export const getCloudTimeBuyDetailUrl = (cloudGameId: number | string) => {
  return `/store/goods/${cloudGameId}/buy/99`
}

/** 前往商品详情页 */
export const toStoreGameDetail = (
  gameLibraryId: number | string,
  gameId: number | string | null,
  key?: TStoreGameNavKey,
  search?: string,
  ornamentId?: number | string,
) => {
  history.push(
    `/store/game/${gameLibraryId}/${gameId || '-'}/${key || ''}${ornamentId ? `/${ornamentId}` : ''}${
      search ? `?${search}` : ''
    }`,
  )
}

/** 前往商品详情页 */
export const toStoreGameDetailByReplace = (
  gameLibraryId: number | string,
  gameId: number | string | null,
  key?: TStoreGameNavKey,
  search?: string,
  ornamentId?: number | string,
) => {
  history.replace(
    `/store/game/${gameLibraryId}/${gameId || '-'}/${key || ''}${ornamentId ? `/${ornamentId}` : ''}${
      search ? `?${search}` : ''
    }`,
  )
}

/** 商品详情页地址 */
export const getStoreGameDetailUrl = (
  gameLibraryId: number,
  gameId: string | number | null,
  key?: TStoreGameNavKey,
  search?: string,
  ornamentId?: number | string,
) => {
  return `/store/game/${gameLibraryId}/${gameId || '-'}/${key || ''}${ornamentId ? `/${ornamentId}` : ''}${
    search ? `?${search}` : ''
  }`
}

/** 公用跳转方法 */
export const commonJump = (url: string, out?: boolean) => {
  if (!out) {
    return history.push(url)
  }
  if (Store.isInClient) {
    return window.FuluApp!.JSNotifyCppFunc('open_url', url)
  }
  window.open(url, '_blank')
}

/** 打开协议弹窗 */
export const showAgreementModal = (type: AgreementType) => {
  Store.protocolVisible = true
  Store.protocolType = type
}

export const checkNextModal = async () => {
  const isShowNewModal = await chcekIsNewUser()
  if (!isShowNewModal && AppStore.authSwitchConfig.loginFlag) {
    isShowAuthModal(true)
  }
}

/**
 * 新人礼包弹出机制（新）
 * 如果没有首充（并且没有设置不再提醒）： 弹出新人礼包弹框
 * 如果有首充过，再判断是否需要弹出新人优惠券弹窗
 */
export const chcekIsNewUser = async () => {
  try {
    const userInfo = UserInfoHS.SuccessResult
    /** 当前用户是标记过不再提醒 */
    const hasMark = await queryUserMarkHS.Execute({ name: 'firstChargeModal', subjectId: userInfo?.id || 0 })
    if (hasMark && hasMark.name === 'firstChargeModal') {
      return false
    }

    const isReceiveNewUserRes = await isReceiveNewUserHS.Execute({ activityNo: 'AT5583243396695234347' })
    // const couponRes = await grantCouponHS.Execute()
    /** 没有首充过 */
    if (
      !isReceiveNewUserRes
      // && !couponRes.reviceCoupon &&
      // couponRes.couponActivityInfoVoList &&
      // couponRes.couponActivityInfoVoList.length > 0
    ) {
      AppStore.newcomerVisisble = true
      return true
    }
    /** 有首充过 */
    // if (
    //   couponRes &&
    //   !couponRes.reviceCoupon &&
    //   couponRes.couponActivityInfoVoList &&
    //   couponRes.couponActivityInfoVoList.length > 0
    // ) {
    //   AppStore.couponVisible1 = true
    //   return true
    // }
    return false
  } catch (error) {
    console.log(error, '检测是否领取过新人礼包')
    return false
  }
}

/**
 * 检测是否需要自动弹出邀请码弹窗
 * 条件一： 当前用户不是永久会员
 * 条件二： 当前用户是首次登录海鲨客户端
 * 条件三： 没有绑定过邀请码
 * 条件四： 当前渠道需要弹出邀请码弹窗
 * */
export const checkIsAnchor = async () => {
  try {
    const token = getPhpToken() || ''
    const userInfo = await UserInfoHS.Execute({ token })
    if (userInfo && userInfo.vip === 2 && userInfo.super_vip_type === 'forever') {
      checkNextModal()
      return
    }

    /** 当前用户是否弹出过邀请码弹窗 */
    const hasMark = await queryUserMarkHS.Execute({ name: 'inviteCodeModal', subjectId: userInfo.id })
    if (hasMark && hasMark.name === 'inviteCodeModal') {
      checkNextModal()
      return
    }

    console.log(GetChannel(), '当前渠道号')
    const invitedUserPhone = await GetVipInvitedUserPhoneHS.Execute()

    const version = await getCMSVersion()
    const anchorChannelRes: ModData<{
      type: string
      blackChannel: string
      whiteChannel: string
    }> = await DWGetModDataByModIdHttp.Execute({ modId: 'simpleclient_ancho_channel_config', version })
    let isViewBindModal = false
    /** 黑名单 */
    if (anchorChannelRes.datas[0].properties.type === '1') {
      isViewBindModal =
        anchorChannelRes.datas[0].properties.blackChannel.split(',').findIndex(d => d === GetChannel()) === -1
    } else {
      /** 白名单 */
      isViewBindModal =
        anchorChannelRes.datas[0].properties.whiteChannel.split(',').findIndex(d => d === GetChannel()) > -1
    }

    /** 未绑定过 并且该渠道需要弹出邀请码弹窗 */
    if (!invitedUserPhone && isViewBindModal) {
      return (AppStore.inviteCodeModal = true)
    }
    checkNextModal()
  } catch (error) {
    console.log(error, '检测是否需要自动弹出邀请码弹窗')
    checkNextModal()
    return (AppStore.inviteCodeModal = false)
  }
}

/**
 *获取焦点隐藏placeholder，失去焦点显示placeholder
 */
export const hackPlaceholder = () => {
  document.addEventListener(
    'focusin',
    e => {
      const el: HTMLInputElement = e.target as HTMLInputElement
      const placeholder = el?.getAttribute('placeholder') ?? ''
      if (!el || !placeholder) {
        return
      }
      el.setAttribute('placeholder', '')
      const onFocusout = () => {
        el.setAttribute('placeholder', placeholder)
        el.removeEventListener('focusout', onFocusout)
      }
      el.addEventListener('focusout', onFocusout, false)
    },
    false,
  )
}
